import { DOCUMENTS_LIST } from '@entities/file/config/documents-constants';
import { DefaultSortOptionValues } from '@shared/ui/dropdown-sort/types';

export const DEFAULT_FILES_LIST_PARAMS = {
    codes: DOCUMENTS_LIST.WELCOM_BANNER,
    order: 'createdAt',
    sort: DefaultSortOptionValues.New,
};
